<template>
  <Modal
    :title="$t('customize_image_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('image')"
      name="featured_image"
    >
      <FileInput
        v-model="form.featured_image"
        name="featured_image"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<ImageBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  featured_image: data.value.item.image
})
</script>
